import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    imports: [RouterLink],
    template: `
        <div class="min-h-screen bg-[#fafaf7] flex items-center justify-center px-4">
            <div class="max-w-sm w-full text-center space-y-6">
                <div class="w-20 h-20 rounded-3xl bg-red-50 flex items-center justify-center mx-auto">
                    <svg class="w-9 h-9 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                    </svg>
                </div>
                <div>
                    <h2 class="text-xl font-semibold text-stone-800">Accès refusé</h2>
                    <p class="text-stone-500 text-sm mt-2 leading-relaxed">
                        Vous n'avez pas les permissions nécessaires pour accéder à cette page.
                    </p>
                </div>
                <a routerLink="/federation/actualites" class="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                    </svg>
                    Retour à l'accueil
                </a>
            </div>
        </div>
    `
})
export class UnauthorizedComponent {}
